import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import ReactTimeout from "react-timeout";
import { BSModal } from "./";
import { toast } from "react-toastify";
class EditButton extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showModal: false,
      showConfirmationModal: false,
      confirmationActions: [],
      confirmationMessage: "",
      submitting: false,
      loadedData: null,
    };
    this.close = this.close.bind(this);
    this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
    this.showForm = this.showForm.bind(this);
    this.validate = this.validate.bind(this);
    this.validated = this.validated.bind(this);
  }
  close(checkConfirmation = true, form = null) {
    if (
      form &&
      this.props.requiresCloseConfirmation &&
      form.props.dirty &&
      form.props.anyTouched &&
      checkConfirmation
    ) {
      this.setState({
        ...this.state,
        showConfirmationModal: true,
        confirmationMessage: this.props.confirmationMessage,
        confirmationActions: [
          {
            id: 1,
            text: <FormattedMessage id="common.confirm" />,
            action: () => {
              this.setState({
                showModal: false,
                showConfirmationModal: false,
                submitting: false,
              });
            },
          },
        ],
      });
    } else {
      this.props.setTimeout(() => {
        this.setState(
          { showModal: false, showConfirmationModal: false, submitting: false },
          () => {
            if (this.props.onModalClosed) {
              this.props.onModalClosed();
            }
          }
        );
      }, 150);
    }
  }
  closeConfirmationModal() {
    this.setState({ showConfirmationModal: false });
  }
  showForm() {
    if(this.props.parentComponentDataLoad) {
      this.props.getData().then(() => {
        this.setState({ showModal: true });
      });
    } 
    else if (!this.props.data && this.props.getData) {
      this.props.getData().then((res) => {
        if (res && res.type != "GET_DATA_ITEM_SUCCESS") {
          toast(<FormattedMessage id="clients.client.errors.fetchingError" />, {
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
          return;
        }
        this.setState({
          showModal: true,
          loadedData: res.payload.data,
        });
      });
    } 
    else {
      this.setState({ showModal: true });
    }
  }
  validate() {
    let form = this.refs.form.getWrappedInstance();
    while (!!form.getWrappedInstance) {
      form = form.getWrappedInstance();
    }
    const submission = form.submit();
    Promise.resolve(submission)
      .then((result) => {
        // Check if result might be an array, this would mean that we receive the result of a Promise.all.
        // Only one instance so far (BasicCoverageGroupFields) and it does not require a confirmation. Close immediately.
        if (typeof result === "undefined" || Array.isArray(result)) {
          this.close(false, form);
        } else {
          this.setState({ submitting: false });
        }
      })
      .then(() => {
        if (this.props.callback) {
          this.props.callback();
        }
      });
  }
  validated(values) {
    const form = !!this.refs.form.getWrappedInstance().refs.wrapped
      ? this.refs.form.getWrappedInstance().refs.wrapped.getWrappedInstance()
      : null;
    if (!!this.props.requiresConfirmation && !!form && form.props.dirty) {
      this.setState({
        ...this.state,
        showConfirmationModal: true,
        confirmationMessage: this.props.confirmationValidMessage(values),
        confirmationActions: [
          {
            id: 1,
            text: <FormattedMessage id="common.confirm" />,
            action: () => {
              this.props.editFunction(values);
              this.close(false, form);
            },
          },
        ],
        //TODO If a form requires Async Validation AND a confirmation popup it will not work. Suggest adding an asyncValidation() to forms, handleSubmit() will handle them all.
      });
      return false;
    }
    this.setState({ submitting: true });
    return this.props.editFunction(values);
  }
  render() {
    let classes = {
      "dataTable-action-button": this.props.datatableActionButton,
      "icon-eye": (!this.props.allowSubmission || this.props.view) && !this.props.add && !this.props.hideEye,
      "add-button": this.props.add,
      "edit-borderless-button": !this.props.add,
      invisible: !this.props.visible,
    };

    if (this.props.reverseIcon) {
      delete classes["edit-borderless-button"];
      classes["reverse-edit-borderless-button"] = this.props.reverseIcon;
    }

    if (this.props.optionalClass) {
      classes["fix-edit-button-margin"] = this.props.optionalClass;
    }

    const actionButtonClassNames = classNames(classes);

    const ready = !this.props.waitForData || this.props.data;
    const actions = [];
    if (this.props.allowSubmission) {
      actions.push({
        id: 1,
        disabled:
          this.props.submitting ||
          this.state.submitting ||
          this.props.blockSubmission,
        text: <FormattedMessage id="common.confirm" />,
        action: this.validate,
      });
    }
    return (
      <span className={this.props.className}>
        <Button
          ref="action"
          className={actionButtonClassNames}
          bsStyle={"primary"}
          bsSize={this.props.add ? null : "xsmall"}
          onClick={this.showForm}
          disabled={this.props.disabled}
        >
          {this.props.label}
        </Button>
        {ready && (
          <BSModal
            backdrop={this.props.disableBackdrop ? false : "static"}
            className={this.props.modalClassName}
            show={this.state.showModal}
            title={this.props.title}
            actions={actions}
            onClose={this.close}
            onEntered={this.props.onModalEntered}
            showCheckBoxUsed={this.props.showCheckBoxUsed}
          >
            <div>
              <this.props.form
                {...this.props.props}
                initialValues={
                  this.state.loadedData != null && this.props.data == null
                    ? this.state.loadedData
                    : this.props.data
                }
                onSubmit={this.validated}
                scene="modal"
                ref={"form"}
                add={this.props.add}
                readOnly={this.props.readOnly}
                reload={this.props.reload}
              />
              {(!!this.props.requiresConfirmation ||
                this.props.requiresCloseConfirmation) && (
                <BSModal
                  backdrop={false}
                  show={this.state.showConfirmationModal}
                  title={this.props.confirmationTitle}
                  actions={this.state.confirmationActions}
                  onClose={this.closeConfirmationModal}
                  closeButtonKey={this.props.closeButtonKey}
                  showCheckBoxUsed={this.props.showCheckBoxUsed}
                >
                  {this.state.confirmationMessage}
                </BSModal>
              )}
            </div>
          </BSModal>
        )}
      </span>
    );
  }
}
EditButton.propTypes = {
  add: PropTypes.bool,
  allowSubmission: PropTypes.bool,
  callback: PropTypes.func,
  className: PropTypes.string,
  confirmationMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  confirmationTitle: PropTypes.object,
  confirmationValidMessage: PropTypes.func,
  data: PropTypes.object,
  datatableActionButton: PropTypes.bool,
  disabled: PropTypes.bool,
  disableBackdrop: PropTypes.bool,
  editFunction: PropTypes.func,
  form: PropTypes.func,
  getData: PropTypes.func,
  hideEye: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  modalClassName: PropTypes.string,
  onModalClosed: PropTypes.func,
  onModalEntered: PropTypes.func,
  props: PropTypes.object,
  readOnly: PropTypes.bool,
  reload: PropTypes.func,
  requiresConfirmation: PropTypes.bool,
  submitting: PropTypes.bool,
  setTimeout: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  view: PropTypes.bool,
  visible: PropTypes.bool,
  waitForData: PropTypes.bool,
  requiresCloseConfirmation: PropTypes.bool,
  closeButtonKey: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  showCheckBoxUsed: PropTypes.number,
  reverseIcon: PropTypes.bool,
  blockSubmission: PropTypes.bool,
  optionalClass: PropTypes.string,
  parentComponentDataLoad: PropTypes.bool
};
EditButton.defaultProps = {
  allowSubmission: true,
  datatableActionButton: true,
  requiresConfirmation: false,
  submitting: false,
  visible: true,
  waitForData: false,
  reverseIcon: false,
  blockSubmission: false,
  hideEye: false
};
function mapStateToProps(state) {
  return {
    submitting: state.data.submitting,
  };
}
export default ReactTimeout(connect(mapStateToProps)(EditButton));



// WEBPACK FOOTER //
// ./src/components/common/EditButton.js